export default __webpack_public_path__ + "static/media/weather.7ade5f7c.png";